import { render, staticRenderFns } from "./AdvertisementDetail.vue?vue&type=template&id=282d2ec2&"
import script from "./AdvertisementDetail.vue?vue&type=script&lang=js&"
export * from "./AdvertisementDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports